"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cutTextByLinesCount = exports.withActiveStyles = exports.card = exports.visuallyHidden = exports.textEllipsis = void 0;
exports.textEllipsis = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
};
exports.visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    padding: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    border: 0,
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
};
const card = ({ theme: { shadows, transition, colors, radii }, }) => ({
    boxShadow: shadows.cardShadow,
    transition: transition.slow,
    borderRadius: radii.default,
    backgroundColor: colors.background,
    border: '1px solid',
    borderColor: colors.borderGreyFifth,
});
exports.card = card;
const withActiveStyles = (isActive, defaultStyles, activeStyles) => {
    return isActive ? Object.assign(Object.assign({}, defaultStyles), activeStyles) : defaultStyles;
};
exports.withActiveStyles = withActiveStyles;
function cutTextByLinesCount(linesCounter) {
    return {
        display: '-webkit-box',
        '-webkit-line-clamp': `${linesCounter}`,
        '-webkit-box-orient': `vertical`,
        overflow: 'hidden',
    };
}
exports.cutTextByLinesCount = cutTextByLinesCount;
//# sourceMappingURL=index.js.map